import * as CoreFns from '../utilities/CoreFns';
import * as SearchForAnEntityType from '../utilities/SearchForAnEntityType';
import * as BaseItems from '../utilities/BaseItems';
import * as ClickElement from './ClickElement';
import ShowCards from '../intro/ShowCards';
import * as IntroFns from '../utilities/IntroFns';
import {fillUpEntityRecursively} from '../utilities/FillUp';
import React, {useEffect, useState} from 'react';
import * as ServerComms from '../utilities/ServerComms';

function App(props) {

  var addToExtraScreen = props.addToExtraScreen;
  var itemT = props.itemT;
  var addPath = props.addPath;
  var position = props.position;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var clickBack = props.clickBack;
  var setItemEdited = props.setItemEdited;
  var userNos = props.userNos;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var width = props.width;
  var userID = props.userID;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var chains = props.chains;
  var changeTab = props.changeTab;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var refObject = props.refObject;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var hidePanelRelativeItems = props.hidePanelRelativeItems;
  var setHidePanelRelativeItems = props.setHidePanelRelativeItems;
  var programSetID = props.programSetID;
  var itemCategories = props.itemCategories;
  var centerZoom = props.centerZoom;

  const [previousDApps, setPreviousDApps] = useState([]);


  function getPreviousDApps(){
    function postGetTemplates2(response){
      var ins = response.v.map((aN, index)=>{
        return {i:aN.v[0].v, con:fillUpEntityRecursively(aN.v[2]), n:aN.v[1].v};
      })

      var ins2 = ins.filter((aC, index)=>{
        var isTemplate = CoreFns.checkIfIsTemplate(aC.con);
        return !isTemplate;
      })
      setPreviousDApps(ins2);
    }

    function postFail(e){
      console.log(e);
    }
    if (itemT === 'fe' || itemT === 'pu'){
      ServerComms.fetchSomething({u:'getOtherDAppsViewableByAUser', programSetID, userID, signKey, sessionID}, postGetTemplates2, postFail);
    }
  }

  useEffect(()=>{
    getPreviousDApps();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!currentList){
    return <div></div>
  }
//
  var actualOptions = IntroFns.actualOptions(itemCategories, itemT);
  var origOptions =  [{i:0, n:'Basic', a:'dashicons:media-default'}].concat(actualOptions);

  if (itemT === 'BUTTON'){
    if (currentList && currentList.sc){
      var smartContracts = currentList.sc;
      var scKeys = Object.keys(smartContracts);
      scKeys.forEach((aKey, index)=>{
        var addSet = smartContracts[aKey].addSet;
        var addSetKeys = Object.keys(addSet);
        var first = addSet[addSetKeys[0]];
        origOptions.push({i:aKey, n:'Functions from ' + first.contractName, a:'material-symbols:contract-outline'})
      })
    }

  }

  if (itemT === 'fe' || itemT === 'pu'){
    var gotPrevious = false;
    for (var i = 0; i < previousDApps.length; i++){
      var thisDApp = previousDApps[i].con;
      var feOrPU = thisDApp[itemT];
      if (feOrPU){
        var nos = Object.keys(itemT).length;
        if (nos > 0){
          gotPrevious = true;
          break;
        }
      }
    }
    if (gotPrevious){
      origOptions.push({i:-1, n:'Previous', a:'ant-design:history-outlined'});
    }
  }else{

    if (itemT === 'navBar'){
      if (currentList.cn){
        var nosCN = Object.keys(currentList.cn).length;
        if (nosCN > 0){
          // gotExisting = true;
          origOptions.push({i:-2, n:'Existing', a:'bx:current-location'});
        }
      }        
    }
    var possibs = SearchForAnEntityType.searchEntity(currentList, itemT); 
    if ((itemT === 'FOOTER' || possibs.length === 0) ){
    }else{
      origOptions.push({i:-1, n:'Previous', a:'ant-design:history-outlined'});
    }

  }

  function clickOption(n){
    return function(e){
      if (n.i === 0){
        if (itemT === 'fe' || itemT === 'pu'){
          var item = {s:{}, nv:{on:0},_s:{"1":{al:{}, _na:'1', i:{}, k:{}, ord:0, hl:{t:'int',v:0}, h:{t:'vh',v:100}, s:{backgroundColor:{t:'raw',v:'rgb(255,255,255)'}}}}};
          if (itemT === 'pu'){
              item = {s:{"paddingOpacity":{"t":"dc","v":0.8},"w":{"t":"vw","v":80}, popUpPadding:{t:'int',v:20}},"nv":{"on":0},"_s":{"1":{"al":{},"_na":"1","i":{},"k":{"c0_ed2fc584":{"t":"CONTAINER","s":{"ord":{"t":"int","v":0}},"oc":{},"i":{"c0_7137d917":{"t":"HFLEX","s":{"ord":{"t":"int","v":0}},"oc":{},"i":{"c0_837f1124":{"t":"SPACE","s":{"colWidth":{"t":"bsu","v":11},"ord":{"t":"int","v":0}},"oc":{},"i":{},"_na":"124"},"c0_5e0f4ada":{"t":"ICON","oc":{"click":{"t":"closePopUp"}},"s":{"icon":{"t":"raw","v":"charm:cross"},"iconColor":{"t":"raw","v":"rgb(0, 0, 0)"},"iconHeight":{"t":"px","v":20},"ord":{"t":"int","v":1},"colWidth":{"t":"bsu","v":1},"padding":{"t":"int","v":0}},"_na":"ada"}},"_na":"917"}},"_na":"584"}},"ord":0,"hl":{"t":"int","v":0},"h":{"t":"vh","v":1},"s":{"backgroundColor":{"t":"raw","v":"rgb(255,255,255)"}}}}};

          }
          var asChanges = [];
          function handleChanges(uuid, changes, startingPanel){
              organicChanges(changes);
              setItemEdited({t:'screen', path:[itemT, uuid, '_s', startingPanel]});
              centerZoom();
              clickBack();
          }

          ClickElement.clickFeOrPu(item, asChanges, itemT, handleChanges, userNos, currentList);
        }else{
          var baseItem = BaseItems.getBaseConstruct(itemT, 0);
          var itemSet = {v:baseItem, as:{}};
          ClickElement.clickItem(itemSet, currentList, itemT, doingWhat, setDoingWhat, addPath, chains, setIsClickingOnContentDiv, userNos, organicChanges, setItemEdited, changeTab, setIsShowingSomeDropDown, hidePanelRelativeItems, setHidePanelRelativeItems, position, insetWidth, insetHeight, refObject);
          clickBack();

        }

      }else{
        if (itemT === 'fe' || itemT === 'pu'){
          addToExtraScreen({t:'pagePopUpSelector', itemT, previousDApps, insetWidth, insetHeight, n:n.i});
        }else{
          addToExtraScreen({t:'elementSelector', itemT, position, insetWidth, insetHeight, addPath, n:n.i})    
        }

      }
    }
  }

  var itemName = CoreFns.getElementInfo(itemT).t;
// , border:'1px solid blue'
  return <div style={{width}} ><center>
    <p className='lead mb-0'>Add {itemName}</p>
    <ShowCards options={origOptions} clickOption={clickOption} />
    </center>
    </div>
}




//
export default App;
